/**
 * 环境配置 - 根据 API_ENV 获取对应的 URL
 */

const API_ENV = process.env.API_ENV; // dev or production

// 课程平台地址
const COURSE_URL = API_ENV === "dev"
    ? "http://localhost:8080/course/"
    : "https://fdddy.com/course/index.html";

// 登录后跳转的首页地址
const HOME_URL = "/";

export {
    API_ENV,
    COURSE_URL,
    HOME_URL,
};

export default {
    API_ENV,
    COURSE_URL,
    HOME_URL,
};
